var _style, _g, _g2, _polygon, _g3, _polygon2, _polygon3, _path, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBorderBottomBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600.2 349.2",
    style: {
      enableBackground: "new 0 0 1600.2 349.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9E2130;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#F6981E;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#A09F9F;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st4{fill:#E2B759;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:#DDDBDB;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n\t.st6{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{display:none;opacity:0.6;}\n\t.st8{display:inline;fill:#730E16;}\n\t.st9{display:inline;opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{opacity:0.6;fill:#8C5E35;}\n\t.st11{opacity:0.3;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1546.8,
    cy: 295.6,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1526.8,275.6c3.5-3.5,13.7,1.1,17.2,4.6s3.5,9.1,0,12.6s-9.1,3.5-12.6,0S1523.3,279.1,1526.8,275.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1522.1,251.2c2.8-6.9-1.7-10.7-8.5-14.2s-5.4-12.5-17.3-17.8s-9.9-11.8-16-16c-6-4.1-26.4-0.5-26.4-0.5 s-3.7,20.3,0.5,26.4c4.1,6,10.6,4.1,16,16c5.4,11.9,14.4,10.5,17.8,17.3c3.5,6.8,7.3,11.3,14.2,8.5 C1511.3,267.2,1518.4,260.1,1522.1,251.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1532.8,190.7c2.3-8.7-3.7-16.8-9.8-18.7s-19.4,2.5-20.8,14.3s6.9,27.6,22.2,30.2c16.6,2.8,30.3-5.1,32.4-23.1 s-5.4-19.8-21.7-52.9c-11.9-24.2-10.8-35.4-8.5-40.6c3.8-8.6,11.2-15.3,22.4-11.8c11.2,3.5,14.3,12.5,11.8,20.7s-10.7,9.3-15.2,6.7 s-6.2-10.1-1.8-13.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1525.9,
    cy: 188.3,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1546.6,
    cy: 105.4,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1526.8,275.6c4.5-4.5,17-8.1,17-8.1s-8.3-0.6-13.4-2.1s-10.6-5.9-10.6-5.9s-2.8,0.8-5.6,3.6 c-2.8,2.8-3.6,5.6-3.6,5.6s4.4,5.5,5.9,10.6s2.1,13.4,2.1,13.4S1522.3,280.1,1526.8,275.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1511.7,235.8c0,0-2.7,9.5-9,15.8c-6.3,6.3-15.8,9-15.8,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1485.5,209.6c0,0-9.5,2.7-15.8,9s-9,15.8-9,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1504,224.7c0,0-3.5,10.3-10.6,17.5c-7.1,7.1-17.5,10.6-17.5,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1467.2,240.2c0,0,9.3-2.5,15.5-8.6c6.1-6.1,8.6-15.5,8.6-15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1440.7,206.3c0,0-30.7,27.8-36.9,37.9c-6.2,10.1-6,18.2-6,18.2l-22.1-8.5c0,0,14.1-5.8,25.1-15.6 c11-9.9,34.2-37.7,34.2-37.7L1440.7,206.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1457.5,189.6c0,0,27.8-30.7,37.9-36.9s18.2-6,18.2-6l-8.5-22.1c0,0-5.8,14.1-15.6,25.1 c-9.9,11-37.7,34.2-37.7,34.2L1457.5,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1441.8,184.2c0,0,5.4-14.1-13.4-32.9s-101-75-101-75s56.2,82.2,75,101s33,13.4,33,13.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1438.6,187.4 1441.8,184.2 1451.8,183.9 1457.5,189.6 1457.1,199.5 1453.9,202.7 1450.7,205.9  1440.7,206.3 1435,200.6 1435.4,190.7  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1446.3,
    cy: 195.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1329.2,78.8 1351.9,93.2 1441.8,184.2 1435.4,190.7 1344.3,100.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1441.8,281.7c-8.7,2.3-16.8-3.7-18.7-9.8s2.5-19.4,14.3-20.8c11.8-1.4,27.6,6.9,30.2,22.2 c2.8,16.6-5.1,30.3-23.1,32.4s-19.8-5.4-52.9-21.7c-24.2-11.9-35.4-10.8-40.6-8.5c-8.6,3.8-15.3,11.2-11.8,22.4 c3.5,11.2,12.4,14.2,20.7,11.6c8.2-2.5,9.3-10.7,6.7-15.2c-2.5-4.4-10.1-6.2-13.7-1.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1439.5,
    cy: 274.8,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1356.6,
    cy: 295.4,
    r: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.8,
    cy: 295.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,275.5c3.5,3.5-1.1,13.7-4.6,17.2s-9.1,3.5-12.6,0s-3.5-9.1,0-12.6C60.1,276.6,70.3,272,73.8,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.3,270.7c6.9,2.8,10.7-1.7,14.2-8.5c3.5-6.8,12.5-5.4,17.8-17.3c5.4-11.9,11.8-9.9,16-16 c4.1-6,0.5-26.4,0.5-26.4s-20.3-3.7-26.4,0.5c-6,4.1-4.1,10.6-16,16s-10.5,14.4-17.3,17.8c-6.8,3.5-11.3,7.3-8.5,14.2 C82.2,260,89.3,267,98.3,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.8,281.5c8.7,2.3,16.8-3.7,18.7-9.8c1.9-6.1-2.5-19.4-14.3-20.8s-27.6,6.9-30.2,22.2 c-2.8,16.6,5.1,30.3,23.1,32.4s19.8-5.4,52.9-21.7c24.2-11.9,35.4-10.8,40.6-8.5c8.6,3.8,15.3,11.2,11.8,22.4 c-3.5,11.2-12.4,14.2-20.7,11.6c-8.2-2.5-9.3-10.7-6.7-15.2c2.5-4.4,10.1-6.2,13.7-1.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 161.1,
    cy: 274.6,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 244,
    cy: 295.3,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,275.5c4.5,4.5,8.1,17,8.1,17s0.6-8.3,2.1-13.4s5.9-10.6,5.9-10.6s-0.8-2.8-3.6-5.6 c-2.8-2.8-5.6-3.6-5.6-3.6s-5.5,4.4-10.6,5.9s-13.4,2.1-13.4,2.1S69.3,271,73.8,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.6,260.4c0,0-9.5-2.7-15.8-9c-6.3-6.3-9-15.8-9-15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.8,234.2c0,0-2.7-9.5-9-15.8s-15.8-9-15.8-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.7,252.7c0,0-10.3-3.5-17.5-10.6c-7.1-7.1-10.6-17.5-10.6-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.2,215.9c0,0,2.5,9.3,8.6,15.5c6.1,6.1,15.5,8.6,15.5,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,189.4c0,0-27.8-30.7-37.9-36.9s-18.2-6-18.2-6l8.5-22.1c0,0,5.8,14.1,15.6,25.1 c9.9,11,37.7,34.2,37.7,34.2L143.1,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.9,206.2c0,0,30.7,27.8,36.9,37.9s6,18.2,6,18.2l22.1-8.5c0,0-14.1-5.8-25.1-15.6 c-11-9.9-34.2-37.7-34.2-37.7L159.9,206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.2,190.5c0,0,14.1,5.4,32.9-13.4s75-101,75-101s-82.2,56.2-101,75S158.7,184,158.7,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "162,187.3 165.2,190.5 165.6,200.4 159.9,206.2 149.9,205.8 146.7,202.6 143.5,199.3 143.1,189.4  148.8,183.7 158.8,184.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 154.3,
    cy: 194.9,
    r: 6.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "270.7,77.8 256.3,100.6 165.2,190.5 158.8,184.1 249.1,93  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.8,190.5c-2.3-8.7,3.7-16.8,9.8-18.7s19.4,2.5,20.8,14.3s-6.9,27.6-22.2,30.2c-16.6,2.8-30.3-5.1-32.4-23.1 s5.4-19.8,21.7-52.9c11.9-24.2,10.8-35.4,8.5-40.6c-3.8-8.6-11.2-15.3-22.4-11.8S37.4,100.3,40,108.6s10.7,9.3,15.2,6.7 c4.4-2.5,6.2-10.1,1.8-13.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 74.7,
    cy: 188.2,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 54,
    cy: 105.3,
    r: 4.5
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "301.6,294.8 629.9,294.8 649.9,314.8 281.6,314.8 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1299,274.9 1319,294.9 1299,314.9 970.7,314.9 950.7,294.9 970.7,274.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1299,315.9 970.7,315.9 950.7,295.9 1319,295.9  "
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1298.2,314.8 1318.2,294.8 1298.2,274.8 799.5,274.8 300.8,274.8 280.8,294.8 300.8,314.8  799.5,314.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1318.1,294.8 1318.2,294.8 1298.2,274.8 799.5,274.8 300.8,274.8 280.8,294.8 280.9,294.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M33.3-0.6c0,29.2,0,47.3,0,47.3l20,20l20-20V-0.6H33.3z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "53.3,-0.6 53.3,66.7 53.3,66.7 73.3,46.7 73.3,-0.6 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1527.1,-1.2 1527.1,46.4 1547.1,66.4 1567.1,46.4 1567.1,-1.2 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1527.1,-1.2 1527.1,46.4 1547.1,66.4 1547.1,66.4 1547.1,-1.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBorderBottomBronze);
export default __webpack_public_path__ + "static/media/certificate-border-bottom-bronze.7d4af3f41ef769af9d20ade92128043f.svg";
export { ForwardRef as ReactComponent };